<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:saveitem="saveItemHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:new="newHandler"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>

import WorkflowForm from "../../../components/personnel/rbworkflowlisting/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import moment from "moment";

export default {
  components: {
    "app-form": WorkflowForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
       search: this.$route.params.search,
      pageTitle: this.$t('rolebasedapproval.editrolebasedworkflowapproval'),
      pageTitleValue: "",
      formData: [],
      headLoading: true,
      loading: true,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    async loadWorkflowHandler() {
      const vm = this;

      try {
      const res = await this.$store.dispatch('get', {url: "/workflow/edit/" + this.id});
      res.data.rec[0].startdate = moment(res.data.rec[0].startdate).format('YYYY-MM-DD');
      res.data.rec[0].enddate = moment(res.data.rec[0].enddate).format('YYYY-MM-DD');
      vm.formData = res.data.rec[0];

      vm.formData.lockstaff = res.data.rec[0].lockstaff;

      vm.pageTitleValue = res.data.rec[0].wftypedesc;
      vm.formData.userid = this.$store.getters.userId;
      console.log("FORMDATA", vm.formData);
      } catch (err) {
      vm.isErr = !vm.isErr;
      vm.errMsg = err;
      }
    },

    async loadWorkflowDetailHandler() {
      const vm = this;

      try {
      const res = await this.$store.dispatch('get', {url: "/workflowd/edit/" + this.id});
      vm.formData.workflowdetails = res.data.rec;

      for (let i = 0; i < vm.formData.workflowdetails.length; i++) {
        Object.assign(vm.formData.workflowdetails[i], { action: 2 });
      }

      vm.loading = false;
      } catch (err) {
      vm.isErr = !vm.isErr;
      vm.errMsg = err;
      }
    },

    saveHandler() {
      //skip saving workflow details
      this.formData.skipWorkflowDetails = true;
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url: "/workflow/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "rbworkflowlist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    saveItemHandler() {
      console.log("SAVEITEM HANDLER");
      console.log("FORMDATA", this.formData);
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url: "/workflow/" + this.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "rbworkflowlist" });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url:
            "/workflow/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "rbworkflowlist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    try {
      await this.loadWorkflowHandler();
      await this.loadWorkflowDetailHandler();
    } finally {
      this.loading = false;
    }
  },
};
</script>